import React from 'react';
import { Link } from 'react-router-dom';
import './Categories.css';
import hubImg from '../../assets/products/hubs.png';
import locksImg from '../../assets/products/locks.png';
import sensorsImg from '../../assets/products/sensors.png';
import switchesImg from '../../assets/products/switches.png';
import switchesCategoryImg from '../../assets/smartcontrollers/Smart Wall Switch H1 Triple Rocker (With Neutral).png';
import camerasImg from '../../assets/products/cameras.png';
import bulbsImg from '../../assets/products/bulbs.png';
import curtainImg from '../../assets/smartcurtain/Curtain Driver E1 (Track Version).png';

const Categories: React.FC = () => {
  const categories = [
    {
      id: 'smart-home-hub',
      name: 'Smart Home Hub',
      image: hubImg,
      description: 'Central devices that connect and control various smart home products seamlessly.',
      count: 11
    },
    {
      id: 'smart-door-locks',
      name: 'Smart Door Locks',
      image: locksImg,
      description: 'Premium smart locks Sri Lanka - Keyless entry with fingerprint & Apple HomeKit integration.',
      count: 11
    },
    {
      id: 'smart-home-sensor',
      name: 'Smart Home Sensor',
      image: sensorsImg,
      description: 'Advanced Aqara sensors for motion, temperature, humidity, and air quality monitoring.',
      count: 18
    },
    {
      id: 'smart-home-controller',
      name: 'Smart Light Switches',
      image: switchesImg,
      description: 'Smart light switches Sri Lanka - Premium Aqara switches with Apple HomeKit support.',
      count: 26
    },
    {
      id: 'switches',
      name: 'Smart Wall Switches',
      image: switchesCategoryImg,
      description: 'Modern smart lighting Colombo - Touch panels and wall switches for luxury homes.',
      count: 13
    },
    {
      id: 'smart-cameras',
      name: 'Smart Cameras',
      image: camerasImg,
      description: 'Monitor your home with security cameras featuring AI detection.',
      count: 9
    },
    {
      id: 'smart-lighting',
      name: 'Smart Lighting',
      image: bulbsImg,
      description: 'LED bulbs and fixtures with adjustable brightness and color.',
      count: 12
    },
    {
      id: 'smart-curtain',
      name: 'Smart Curtain',
      image: curtainImg,
      description: 'Automate your curtains and shades with motorized controllers.',
      count: 7
    },
  ];

  return (
    <section id="products" className="categories">
      <div className="categories-container">
        <span className="section-badge">LUXURY SMART HOME SOLUTIONS</span>
        <h2 className="categories-title">
          Best Smart Home Automation <span className="highlight">Sri Lanka</span>
        </h2>
        <p className="categories-subtitle">
          Explore our premium range of Aqara smart products - from smart light switches to smart door locks
        </p>

        <div className="categories-grid">
          {categories.map((category) => (
            <Link 
              key={category.id} 
              to={`/category/${category.id}`} 
              className="category-card"
            >
              <div className="category-image">
                <img src={category.image} alt={category.name} />
              </div>
              <h3 className="category-name">{category.name}</h3>
            </Link>
          ))}
        </div>

        <a href="https://wa.me/+94774641111" className="learn-more-btn">
          Learn More
        </a>
      </div>
    </section>
  );
};

export default Categories;
